module.exports = __webpack_public_path__ + "static/media/image.eeea9433.jpg";